import type { AppFooterNavItem, AppFooterSocialItem } from './types';

export const navItems: AppFooterNavItem[] = [
  {
    title: 'Проекты',
    items: [
      {
        label: 'Комьюнити',
        href: 'https://www.4dk.ru/content',
        external: true,
      },
      {
        label: 'Калькуляторы',
        href: 'https://www.4dk.ru/home/myspace#/instruments/calculators',
        external: true,
      },
      {
        label: 'Производственный календарь',
        href: 'https://www.4dk.ru/s/calendar',
        external: true,
      },
      {
        label: 'Путеводители',
        href: 'https://www.4dk.ru/consultant-plus/putevoditeli',
        external: true,
      },
      {
        label: 'Помощь Информер',
        href: 'https://www.4dk.ru/informer-faq',
        external: true,
      },
      {
        label: 'Тесты',
        href: 'https://www.4dk.ru/tests',
        external: true,
      },
    ],
  },
  {
    title: 'Наши продукты',
    items: [
      {
        label: 'Прайс-лист 1С',
        href: 'https://www.4dk.ru/files/332536/%D0%9F%D1%80%D0%B0%D0%B9%D1%81_1%D0%A1_%D0%BE%D1%82_07.08.24.pdf',
        external: true,
      },
      {
        label: 'Купить Консультант Плюс',
        href: '/consultant-plus/prices',
        external: false,
      },
      {
        label: 'Купить 1С',
        href: 'https://www.4dk.ru/1c',
        external: true,
      },
      {
        label: 'Записаться на семинар',
        href: 'https://www.4dk.ru/seminars',
        external: true,
      },
      {
        label: 'Попробовать Консультант Плюс',
        href: '/consultant-plus/big-test-drive',
        external: false,
      },
    ],
  },
  {
    title: 'О компании',
    items: [
      {
        label: 'Вакансии',
        href: 'https://www.4dk.ru/vacancies',
        external: true,
      },
      {
        label: 'О нас',
        href: 'https://www.4dk.ru/s/about-us',
        external: true,
      },
      {
        label: 'Контакты',
        href: 'https://www.4dk.ru/contacts',
        external: true,
      },
      {
        label: 'Правовая документация',
        href: '/pravdocs',
        external: true,
      },
    ],
  },
];

export const socialItems: AppFooterSocialItem[] = [
  {
    icon: 'vk_color',
    link: 'https://vk.com/company4dk',
    alt: 'Наш канал в Вконтакте',
  },
  {
    icon: 'youtube_color',
    link: 'https://www.youtube.com/@company4dk',
    alt: 'Наш канал на youtube',
  },
  {
    icon: 'ok_color',
    link: 'https://ok.ru/group/70000002697059',
    alt: 'Наша группа в однокласниках',
  },
  {
    icon: 'tenchat_color',
    link: 'https://tenchat.ru/company4dk',
    alt: ' Наш канал в tenchat',
  },
  {
    icon: 'vc_color',
    link: 'https://vc.ru/u/2016794-chto-delat-konsalt',
    alt: ' Наш канал на vc',
  },
  {
    icon: 'dzen_color',
    link: 'https://dzen.ru/company4dk',
    alt: 'Наш профиль на дзен',
  },
  {
    icon: 'megasreda_color',
    link: 'https://megasreda.ru/company4dk',
    alt: 'Наш профиль на мегасреде',
  },
];
